<template>
  <div id="mp-config-cjs">
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <div class="sidebar-heading">Konfigurator CreateJS</div>
        <div class="list-group list-group-flush">
          <a href="#" class="list-group-item list-group-item-action bg-light" @click="game = 'codingMat'">
            <font-awesome-icon :icon="['fab', 'deezer']"></font-awesome-icon>
            Mata do kodowania
          </a>
          <a href="#" class="list-group-item list-group-item-action bg-light disabled"> Drag 'n Drop </a>
          <a href="#" class="list-group-item list-group-item-action bg-light disabled">Sortowanie</a>
          <a href="#" class="list-group-item list-group-item-action bg-light" @click="game = 'connect'">
            <font-awesome-icon :icon="['fab', 'hubspot']"></font-awesome-icon>
            Łączenie
          </a>
          <a href="#" class="list-group-item list-group-item-action bg-light disabled">Zaznaczanie</a>
          <a href="#" class="list-group-item list-group-item-action bg-light disabled">Zegary</a>
          <a href="#" class="list-group-item list-group-item-action bg-light disabled">3D</a>
        </div>
      </div>
      <div id="page-content-wrapper">
        <nav class="navbar navbar-expand-lg navbar-light bg-light border-bottom">
          <button class="btn btn-primary" id="menu-toggle">
            Menu
            <font-awesome-icon :icon="['fas', 'list']"></font-awesome-icon>
          </button>

          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>

          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <img
              draggable="false"
              class="navbar-nav exit-icon controll-icon"
              @click="closeConfigCJS()"
              :src="exitIcon"
            />
          </div>
        </nav>
        <div class="container-fluid">
          <div v-if="game == 'codingMat'">
            <h1>Mata do kodowania</h1>
            <hr />
            <div class="row">
              <div class="col-4 border-right">
                <div class="row">
                  <div class="col">
                    <label for="wItem" class="col-form-label">Szerokość</label>
                    <div class="d-flex justify-content-center">
                      <div class="w-75">
                        <input
                          type="range"
                          class="custom-range"
                          id="wItem"
                          min="1"
                          max="200"
                          v-model="gameJS.widthItem"
                        />
                      </div>
                      <span class="font-weight-bold text-primary ml-2" id="wItemValue">{{ gameJS.widthItem }}</span>
                    </div>
                    <label for="hItem" class="col-form-label">Wysokość</label>
                    <div class="d-flex justify-content-center">
                      <div class="w-75">
                        <input
                          type="range"
                          class="custom-range"
                          id="hItem"
                          min="1"
                          max="200"
                          v-model="gameJS.heightItem"
                        />
                      </div>
                      <span class="font-weight-bold text-primary ml-2" id="hItemValue">{{ gameJS.heightItem }}</span>
                    </div>
                  </div>
                  <div class="col text-center">
                    Podgląd elementu
                    <div
                      id="previewSource"
                      :style="{
                        backgroundColor: gameJS.colorBgrTarget,
                        width: gameJS.widthItem + 'px',
                        height: gameJS.heightItem + 'px',
                      }"
                    ></div>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="inputRows" class="col-sm-3 col-form-label">Wiersze</label>
                  <div class="col-sm-9">
                    <input
                      type="text"
                      class="form-control"
                      id="inputRows"
                      placeholder="Liczba wierszy"
                      v-model="gameJS.rows"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="inputCols" class="col-sm-3 col-form-label">Kolumny</label>
                  <div class="col-sm-9">
                    <input
                      type="text"
                      class="form-control"
                      id="inputCols"
                      placeholder="Liczba kolumn"
                      v-model="gameJS.cols"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="inputBgrTarget" class="col-sm-3 col-form-label">Kolor kwadratów</label>
                  <div class="col-sm-9">
                    <div id="hookColor" class="itemColor input-group" title="Wybierz kolor">
                      <input
                        id="hookColorValue"
                        type="text"
                        class="form-control input-lg"
                        v-model="gameJS.colorBgrTarget"
                      />
                      <span class="input-group-append">
                        <span class="input-group-text colorpicker-input-addon"><i></i></span>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="form-group form-check">
                  <input type="checkbox" class="form-check-input" id="checkGame" v-model="gameJS.withoutCheck" />
                  <label class="form-check-label" for="checkGame">Bez sprawdzania</label>
                </div>
                <hr />
                <div class="container">
                  <div class="row">
                    <input type="hidden" name="count" value="1" />
                    <div class="control-group" id="fields">
                      <label class="control-label">Kolory do kodowania</label>
                      <div id="sources">
                        <div class="itemColor input-group entry" title="Wybierz kolor" id="cpItem">
                          <input
                            type="text"
                            class="form-control input-lg"
                            name="items"
                            value="#ffffff"
                            placeholder="Kolor"
                            data-items="8"
                            id="s1"
                          />
                          <span class="input-group-append">
                            <span class="input-group-text colorpicker-input-addon"><i></i></span>
                          </span>
                          <div class="input-group-append">
                            <button id="removeRow" type="button" class="btn btn-danger">-</button>
                          </div>
                        </div>

                        <div id="newSource"></div>
                        <button id="addSource" type="button" class="btn btn-info">Dodaj kolor</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-8">
                <h2>Logika gry</h2>
                <div class="row">
                  <div class="col-12">
                    <canvas id="previewGame" class="border"></canvas>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <mp-connect v-else-if="game == 'connect'" :game-js="gameJS" @changeConfig="onUpdateGame"></mp-connect>
          <div v-else>
            <h1>Wybierz grę</h1>
          </div>
          <div v-if="game == 'codingMat' || game == 'connect'">
            <hr />
            <div class="row text-center">
              <div class="col">
                <button id="generate" class="btn btn-success" type="button" @click="runGenerateGame()">
                  Uruchom grę
                  <font-awesome-icon :icon="['fas', 'cogs']"></font-awesome-icon>
                </button>
              </div>
              <div class="col">
                <button id="printJson" class="btn btn-primary" type="button" @click="runPrintConfigJSON()">
                  Drukuj config.json
                  <font-awesome-icon :icon="['fas', 'print']"></font-awesome-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="modal-fade">
      <mp-createjs
        v-if="generateGame == true"
        :start-game-config="gameJS.getConfigGame()"
        :with-close="true"
        @closeCreateJS="closePreviewGame()"
      ></mp-createjs>
    </transition>
  </div>
</template>

<script>
import _ from 'lodash';
import * as $ from 'jquery';
import 'bootstrap';
import 'bootstrap-colorpicker';

import MpCreateJS from '__mainSrcDir/components/TrGame/v4/GameEngines/MpCreateJS/MpCreateJS';
import MpConnect from './vue/MpConnect';

import { CodingMat } from './js/codingMat.js';
import { Connect } from './js/connect.js';
import { BaseEngine } from './js/baseEngine.js';

export default {
  name: 'mp-config-cjs',
  components: { 'mp-createjs': MpCreateJS, 'mp-connect': MpConnect },
  data: function () {
    return {
      game: null,
      prevRoute: null,
      gameJS: {},
      generateGame: false,
      cjsStage: null,
      preStage: null,
    };
  },
  mounted() {
    $('#menu-toggle').click(function (e) {
      e.preventDefault();
      $('#wrapper').toggleClass('toggled');
    });
    let self = this;
    $('a').click(function (e) {
      e.preventDefault();
      switch (self.game) {
        case 'codingMat':
          self.gameJS = new CodingMat();
          self.initCodingMat();
          break;
        case 'connect':
          self.gameJS = new Connect();
          break;
      }
      $('#checkGame').change(function (e) {
        e.preventDefault();
        self.gameJS.withoutCheck = this.checked;
      });

      $('#generate').click(function (e) {
        e.preventDefault();
        console.log(self.gameJS.getConfigGame());
      });
    });
    $(document).on('change', 'input.custom-file-input', function () {
      let fileName = $(this).val().split('\\').pop();
      $(this).siblings('.custom-file-label').addClass('selected').html(fileName);
    });

    // try {
    //   if (this.cjsStage != null) this.cjsStage.beforeDestroy();
    //   this.cjsStage = new cjsStage(this.gameJS.getConfigGame(), {
    //     getDefaultFont: this.$store.getters.getDefaultFont,
    //     multibookType: this.$store.getters.multibookType,
    //   });
    //   if (this.cjsStage != null) {
    //     Promise.all(this.cjsStage._fonts)
    //       .catch((err) => {
    //         console.log(err);
    //       })
    //       .finally(() => {
    //         self.cjsStage.initGame();
    //         // self.cjsStage.stage.on('mousedown', self.stageMouseDown);

    //         self.cjsStage.runFunctionEngine('afterLoadSamples');
    //         self.cjsStage.runFunctionEngine('defineKeys');
    //         self.runPromises();
    //       });
    //   }
    // } catch (e) {
    //   if (this.cjsStage != null) this.cjsStage.beforeDestroy();
    //   delete this.cjsStage;
    //   console.log('ZNOWU SIĘ ZJEBAŁO');
    //   console.log(e);
    // }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
      console.log(from);
    });
  },
  methods: {
    onUpdateGame(param) {
      this.gameJS = param.gameJS;
      this.preStage = param.preStage;
    },
    initCodingMat() {
      let self = this;
      let next = 1;
      $('.itemColor').colorpicker({ format: 'rgba', color: this.gameJS.colorBgrTarget });
      $('#hookColorValue').change(function (e) {
        self.gameJS.colorBgrTarget = $(this).val();
      });

      $('input[name="items"]').change(function (e) {
        self.gameJS.changeColorSource(this);
      });

      $('#addSource').click(function () {
        next++;
        let html = '';
        html += '<div class="itemColor input-group entry" title="Wybierz kolor" id="cpItem">';
        html +=
          '<input type="text" class="form-control input-lg" name="items" value="#ffffff" id="s' +
          next +
          '" placeholder="Kolor" data-items="8" />';
        html += '<span class="input-group-append">';
        html += '<span class="input-group-text colorpicker-input-addon"><i></i></span>';
        html += '</span>';
        html += '<div class="input-group-append">';
        html += '<button id="removeRow" type="button" class="btn btn-danger">-</button>';
        html += '</div>';
        html += '</div>';

        $('#newSource').append(html);

        $('.itemColor').colorpicker({ format: 'rgba', color: 'rgb(255, 255, 255)' });
        $('input[name="items"]').change(function (e) {
          self.gameJS.changeColorSource(this);
        });

        self.gameJS.addColorSource('s' + next);
      });

      // remove row
      $(document).on('click', '#removeRow', function () {
        self.gameJS.removeColorSource($($(this).closest('#cpItem').find('input')).attr('id'));
        $(this).closest('#cpItem').remove();
      });
    },
    runGenerateGame() {
      this.generateGame = true;
      if (this.$refs.createJS != undefined && this.$refs.createJS != null) {
        this.$refs.createJS.closed = false;
        this.$refs.createJS.resetGameAction();
      }
    },
    runPrintConfigJSON() {
      let blob = new Blob([this.gameJS.printConfigJSON()], {
        type: 'application/octet-stream',
      });

      let url = URL.createObjectURL(blob);
      let link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', 'gameData.config.js');

      let event = document.createEvent('MouseEvents');
      event.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 0, null);
      link.dispatchEvent(event);
    },
    checkGenerateGame() {
      console.log(this.$refs);
      if (this.$refs.createJS != undefined && this.$refs.createJS != null && this.$refs.createJS.closed == true) {
        this.generateGame = false;
      }
      return this.generateGame;
    },
    closePreviewGame() {
      console.log('CLOSE PREVIEW');
      this.generateGame = false;
      this.preStage.reRunTicker();
    },
    closeConfigCJS() {
      if (this.preStage != null) {
        this.preStage.beforeDestroy();
      }
      if (this.prevRoute) {
        if (this.prevRoute.fullPath == '/') this.redirectMain();
        this.$router.push({ name: this.prevRoute.name, params: this.prevRoute.params });
      } else {
        this.redirectMain();
      }
    },
    redirectMain() {
      this.$router.push(`/`);
    },
    giveMeImagePlease(path) {
      try {
        return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
      } catch (err) {
        console.log(err);
      }
    },
  },
  computed: {
    exitIcon() {
      try {
        return require(`__mainSrcDir/assets/icons/grid/gameInterface/exit-64px.png`);
      } catch {
        console.log(
          '%cexitIcon MpCreateJS- error',
          'font-weight: bold; background: red; color: white; padding: 0px 10px'
        );
      }
      return null;
    },
  },
};
</script>
<style lang="sass">
.btn
  position: relative !important
.accordion
  margin-top: 20px
</style>
<style lang="sass" scoped>
$break-large: 1400px
#mp-config-cjs
  width: 100%
  position: absolute
  top: 0
  height: 100%
  z-index: 8
  background: -webkit-linear-gradient(top, #ffffff, #bdbdbd)

#wrapper
  overflow-x: hidden

#sidebar-wrapper
  min-height: 100vh
  margin-left: -15rem
  transition: margin .25s ease-out
  .disabled
    opacity: 1
    font-style: italic
    cursor: not-allowed
    pointer-events: all !important

#sidebar-wrapper .sidebar-heading
  padding: 0.875rem 1.25rem
  font-size: 1.2rem

#sidebar-wrapper .list-group
  width: 15rem

#page-content-wrapper
  min-width: 100vw
  .navbar
    margin-top: 0px

#wrapper.toggled #sidebar-wrapper
  margin-left: 0

.entry:not(:first-of-type)
  margin-top: 10px

#previewSource
  border: 2px solid black
  margin: 0 auto

#previewGame
  width: 100%
  height: 100%
  background-color: #ffffff

#addGroup
  margin-bottom: 20px

@media (min-width: 768px)
  #sidebar-wrapper
    margin-left: 0

  #page-content-wrapper
    min-width: 0
    width: 100%


  #wrapper.toggled #sidebar-wrapper
    margin-left: -15rem

.controll-icon
  width: 64px
  height: 64px
  top: calc(64px/3 + 64px/4)
  position: absolute
  right: calc(64px/3 + 64px/4)
  transition: .5s
  transform: scale(.9)
  cursor: pointer
  z-index: 10
  &:hover
  transform: scale(1)
.exit-icon
  animation: 1s .3s iconShow 1 linear backwards

@keyframes iconShow
  0%
    opacity: 0
    transform: rotate(-25deg) scale(.9)
  50%
    opacity: 1
    transform: rotate(-25deg) scale(.9)
  100%
    opacity: 1

.modal-fade-leave-active, .modal-fade-enter-active
  transition: all .5s linear
.modal-fade-leave-to, .modal-fade-enter
  opacity: 0
</style>
